import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  EmojiEvents,
  CardGiftcard,
  Email,
} from "@mui/icons-material";

const MilestoneRewardPopup = ({ open, onClose, milestoneData }) => {
  if (!milestoneData) return null;

  const { title, message, rewards } = milestoneData;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          color: "#ffffff",
          pt: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <EmojiEvents
            sx={{
              fontSize: 80,
              color: "#ffd700",
              animation: "bounce 1s infinite",
              "@keyframes bounce": {
                "0%, 100%": { transform: "translateY(0)" },
                "50%": { transform: "translateY(-10px)" },
              },
            }}
          />
          <Typography variant="h4" sx={{ fontWeight: 700, color: "#ffffff" }}>
            🎉 {title}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent
        sx={{
          bgcolor: "#ffffff",
          mx: 2,
          mb: 2,
          borderRadius: 2,
          p: 3,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            mb: 3,
            textAlign: "center",
            fontSize: "1.1rem",
            color: "#333",
            lineHeight: 1.6,
          }}
        >
          {message}
        </Typography>

        <Box
          sx={{
            bgcolor: "#f5f5f5",
            borderRadius: 2,
            p: 2,
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 2,
              color: "#667eea",
              fontWeight: 600,
            }}
          >
            <CardGiftcard /> Your Rewards:
          </Typography>
          <List dense>
            {rewards.map((reward, index) => (
              <ListItem key={index} sx={{ py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 30 }}>
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      bgcolor: "#667eea",
                    }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={reward}
                  primaryTypographyProps={{
                    sx: { fontWeight: 500, color: "#333" },
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>

        <Box
          sx={{
            bgcolor: "#F0F8FF",
            borderRadius: 2,
            p: 2,
            border: "1px solid #1E40AF",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              color: "#001A4D",
              fontWeight: 600,
            }}
          >
            <Email fontSize="small" /> Next Steps:
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, color: "#555" }}>
            Please contact our admin team at{" "}
            <strong>infinitywhale08@gmail.com</strong> to claim your rewards.
            An email notification has been sent to both you and the admin team.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          pb: 3,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          size="large"
          sx={{
            bgcolor: "#ffffff",
            color: "#667eea",
            fontWeight: 600,
            px: 4,
            "&:hover": {
              bgcolor: "#f5f5f5",
            },
          }}
        >
          Got It!
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MilestoneRewardPopup;
